import React from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Group,
  Title
} from '@mantine/core';
import { Link } from 'react-router-dom';

import CareManagerList from '../components/caremanager/CareManagerList';

const ManageCareManagers: React.FC = () => {
  return (
    <>
      <Group justify="space-between" mb="xl">
        <Title order={1}>Manage Care Managers</Title>
        <Button
          component={Link}
          leftSection={<FontAwesomeIcon icon={faPlus} />}
          to="/care_manager/add"
          variant="filled"
        >
          Add Care Manager
        </Button>
      </Group>

      <CareManagerList title="Care Managers" />
    </>
  );
};

export default ManageCareManagers;
